export const enabledAdFit = window.Config.hasOwnProperty('revenue') && window.Config.revenue.includes('adfit');
